import React from 'react'
import { Link } from 'react-router-dom';
import { Element, Link as ScrollTo } from 'react-scroll';

const Banner = () => {
  return (
    <>
      <Element className="edge-ai-banner ipp-banner banner-style-1 d-flex align-items-center justify-content-center">
        <div className="container eduvibe-animated-shape">
          <div className="row g-5 align-items-center">
            <div className="order-1 order-xl-1 col-lg-12 col-xl-7 banner-left-content">
              <div className="inner">
                <div className="content position-relative">
                  <div className="d-flex align-items-center">
                    <Link to="/">Home</Link>
                    <i className="ri-arrow-drop-right-line"></i>
                    Industry Partner Programs
                  </div>
                  <h1 className="title mt-5 mt-md-4">Industry Partner Programs</h1>
                  <p>
                    Subheading text Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quis labore eveniet ad, eligendi dignissimos velit doloremque excepturi! Nisi officiis dignissimos, nulla ex, odio debitis laudantium omnis recusandae, id quibusdam quod?
                  </p>
                  <div className="read-more-btn banner-btns">
                    <ScrollTo
                      className="edu-btn btn-primary text-center"
                      to="ipp-list"
                      spy={true}
                      smooth={true}
                      duration={200}
                    >
                      Browse Programs<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i>
                    </ScrollTo>
                    <Link className="edu-btn btn-bg-alt text-center" to="/contact-us">
                      Take A Skill Assessment<i className="icon-arrow-right-line-right d-none d-md-inline-block"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="order-2 order-xl-3 col-lg-12 col-xl-5 d-flex flex-column align-items-center justify-content-center banner-right-content">
              <div className="ipp-banner-right-wrapper position-relative">
                <img className="" src={`${process.env.PUBLIC_URL}/images/industry-partner-programs/industry_partner_programs_hero.jpg`} alt="Students discussing on a bench" loading="lazy" />
                <div className="ipp-banner-tag position-absolute">
                  🚀 Expert-Led
                </div>
                <div className="ipp-banner-card position-absolute">
                  <strong>Thousands Trained</strong><br></br>
                  <span className="color-primary"><strong>10,000 +</strong></span><br></br>
                  learning & growing
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default Banner;